import { create } from 'zustand';

interface OrgPortalProps {
  portalId: number;
  orgId: number;
  setOrgPortal: (orgId: number, portalId: number) => void;
}

export const useOrgPortal = create<OrgPortalProps>(set => ({
  portalId: -1,
  orgId: -1,
  setOrgPortal: (orgId, portalId) => {
    console.log('useOrgPortal:setOrgPortal', { portalId, orgId });
    set({ orgId, portalId });
  },
}));
